const uri = window.location.origin;

export const logErrorEvent = data => {
  return fetch(`${uri}/backend-vald/logerror`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: data,
  });
};

export const logV2Event = (token, header, data) => {
  return fetch(`${uri}/backend-vald/v2/logging`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'SessionToken': token,
      'Authorization': 'bearer ' + header
    },
    body: data,
  });
};
